import { ToastContainer, toast } from "react-toastify";
import Header from '../Header/Header';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import icon02 from "../../../screenassets/images/cta/02.png";
import { useEffect, useState } from "react";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { fetchUsers } from "../../../service/slice/AuthSlice";
import { useDispatch } from "react-redux";



export default function GoogleVerified() {
    const [board, setBoard] = useState([]);
    const [othersBoard, setOthersBoard] = useState({
        type: "",
        value: ""
    });
    const [languages, setLanguages] = useState([]);
    const [othersLanguages, setOthersLanguages] = useState([]);
    const [level, setlevel] = useState();
    const navigate = useNavigate();
    const authToken = localStorage.getItem("authAdminToken");
    const animatedComponents = makeAnimated();

    const location = useLocation();
    const userData = location.state;
    const dispatch = useDispatch()

    // Fetch All Language
    const fetchLang = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllLanguage`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authToken}`
            },
        });
        return response.json();
    };

    // Fetch All Study Profile
    const fetchStudyProfile = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getStudyProfile`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${authToken}`
            },
        });
        return response.json();
    };


    useEffect(() => {
        fetchStudyProfile().then((res) => {
            if (res.status) {
                setBoard(res?.studyProfile)
            } else {
                toast.error("Failed to load languages. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch languages at the moment.");
        });

        fetchLang().then((res) => {
            if (res.status) {
                setLanguages(res?.languages)
            } else {
                toast.error("Failed to load languages. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch languages at the moment.");
        });
    }, []);

    async function handleSubmit(event) {
        event.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/validatePartials`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    board: othersBoard.value,
                    medium: JSON.stringify(othersLanguages.map((elem) => { return elem.value })),
                    level: level,
                    email: userData.email,
                    otp: userData.otp
                }),
            });
            const data = await response.json();
            if (data.status) {
                toast.success("Signin successful!");
                localStorage.setItem("authToken", data.token);
                dispatch(fetchUsers({ token: data.token, type: "user" }))
                window.location.href = "/user/dashboard";
            } else {
                toast.error("An error occurred. Please try again later.");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }

    return (
        <>

            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Continue with your details</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Sign in with google</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Form Section */}
            <div className="rts-register-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="single-form-s-wrapper">
                                <div className="head">
                                    <span>Start your Journey</span>
                                    <h5 className="title">Add your details</h5>
                                </div>
                                <div className="body">
                                    <form onSubmit={(event) => { handleSubmit(event) }}>

                                        <div className="input-wrapper mt-4">
                                            <input type="email" value={userData.email} placeholder="Email" Style="border:none !important" disabled />
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <select value={othersBoard.value} onChange={(event) => { setOthersBoard({ value: event.target.value == "Others" ? "" : event.target.value, type: event.target.value }); if (event.target.value !== "Others") { var selectMedium = JSON.parse(board.filter((elem) => elem.board == event.target.value)[0].medium); setOthersLanguages([...othersLanguages, ...selectMedium.map((elem) => { return { value: elem, label: elem } })]) } else { setOthersLanguages([]) } }} required>
                                                <option value="">Select Board</option>
                                                {board.map((study, idx) => {
                                                    return <option key={idx} value={study.board}>{study.board}</option>
                                                })
                                                }
                                                <option value="Others">Others Board</option>
                                            </select>
                                        </div>

                                        {othersBoard.type == "Others" && (
                                            <div className="input-wrapper mt-4">
                                                <input type="text" value={othersBoard.value} onChange={(event) => { setOthersBoard({ ...othersBoard, value: event.target.value }) }} placeholder="Board Name" Style="border:none !important" required />
                                            </div>
                                        )}

                                        { /* Language Section */}
                                        <Select
                                            className='mt-3'
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            defaultValue={othersLanguages}
                                            value={othersLanguages}
                                            isMulti
                                            options={[...languages.map((lang, index) => ({ value: lang.language, label: lang.language })), { value: "Others Language", label: "Others Language" }]}
                                            onChange={(value) => { setOthersLanguages(value) }}
                                            placeholder={<div className='d-flex p-0' Style="width: 150px !important;">Select Medium</div>}
                                        />

                                        {othersLanguages.filter((elem) => elem.label == "Others Language").length > 0 && (
                                            <div className="input-wrapper mt-4">
                                                <input type="text" placeholder="Other Language" Style="border:none !important" onChange={(event) => { const data = structuredClone(othersLanguages); data.map((elem) => { if (elem.label == "Others Language") { elem.value = event.target.value }; return elem; }); setOthersLanguages(data) }} required />
                                            </div>
                                        )}

                                        <div className="input-wrapper mt-4">
                                            <select value={level} onChange={(event) => { setlevel(event.target.value) }} required>
                                                <option value="">Select Level</option>
                                                <option value="6-8">6-8</option>
                                                <option value="9-10">9-10</option>
                                                <option value="11-12">11-12</option>

                                            </select>
                                        </div>

                                        <button type='submit' className="rts-btn btn-primary text-white">Submit</button>

                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Section */}
            <Footer />
        </>
    )
}
